module.exports = __webpack_public_path__ + "static/showreel-b2f80c8be04f15167efb70ed980a6bff.jpeg";